import { render, staticRenderFns } from "./modalAddGroups.vue?vue&type=template&id=7859b966&"
import script from "./modalAddGroups.vue?vue&type=script&lang=js&"
export * from "./modalAddGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports